import { NgModule } from '@angular/core';

import { CommonUIModule } from '../common-ui';

import {
  AccordionComponent,
  AccordionContentComponent,
  AccordionItemComponent,
  AccordionTitleComponent,
} from './accordion';

@NgModule({
  declarations: [
    AccordionComponent,
    AccordionItemComponent,
    AccordionTitleComponent,
    AccordionContentComponent,
  ],
  exports: [
    AccordionComponent,
    AccordionItemComponent,
    AccordionTitleComponent,
    AccordionContentComponent,
  ],
  imports: [CommonUIModule],
})
export class AccordionModule {}
